import Vue from 'vue'
import Vuex from 'vuex'
import CommonModule from '../store/modules/common/index'
import ModalModule from '../store/modules/modal'
import UserModule from '../store/modules/user'
import ConnectorModule from '../store/modules/connector'
import PackageModule from '../store/modules/package'
import WalletModule from '../store/modules/wallet'
import StakeModule from '../store/modules/staking'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    CommonModule,
    ModalModule,
    UserModule,
    ConnectorModule,
    PackageModule,
    WalletModule,
    StakeModule
  }
})

export default store
